module.exports = __webpack_public_path__ + "static/media/evo_gaming.8cf31040.svg";